import { Tab } from "semantic-ui-react";

import Solutran from "./solutran";

/**
 * What the EBT Card tab accepts. Only call site is `food/index.tsx`.
 *
 * A pass-through onto `Solutran`, so every field is taken from that component's
 * props. Its only contribution is two renames: it accepts
 * `solutranView`/`setSolutranView` and forwards them as `view`/`setView`.
 */
type SolutranProps = React.ComponentProps<typeof Solutran>;

type EBTCardProps = Omit<SolutranProps, 'view' | 'setView'> & {
    solutranView?: SolutranProps['view'];
    setSolutranView: SolutranProps['setView'];
};

export default function EBTCard(props: EBTCardProps) {

    return (
        <Tab panes={[
            {
                menuItem: 'Solutran',
                render: () =>
                    <Tab.Pane>
                        <Solutran
                            ordersData={props.ordersData}
                            ordersMutate={props.ordersMutate}
                            org={props.org}
                            view={props.solutranView}
                            setView={props.setSolutranView}
                            solutranMakePaymentSelectedOrder={props.solutranMakePaymentSelectedOrder}
                            setSolutranMakePaymentSelectedOrder={props.setSolutranMakePaymentSelectedOrder}
                            solutranPastPaymentsSelectedOrder={props.solutranPastPaymentsSelectedOrder}
                            setSolutranPastPaymentsSelectedOrder={props.setSolutranPastPaymentsSelectedOrder}
                        />
                    </Tab.Pane>
            },
        ]} />
    )
}